import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'button'];

  connect() {
    this.toggleButton();
  }

  checkboxChangeHandler() {
    this.toggleButton();
  }

  toggleButton() {
    if (this.checkboxTarget.checked) {
      this.buttonTarget.classList.remove('disable');
    } else {
      this.buttonTarget.classList.add('disable');
    }
  }
}
